import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  NavProgressBaseService,
  normalizePath,
} from 'app/services/navigation/nav-progress-base.service';

const PARAMETRE_PREFIX = '/main/parametre/';

/**
 * Barre de progression de navigation pour les pages de paramétrage (`/main/parametre/**`).
 *
 * La logique commune (timers, progression, requêtes HTTP) vit dans {@link NavProgressBaseService}.
 * Ce service ne fait que restreindre le suivi aux URLs de paramétrage.
 */
@Injectable({ providedIn: 'root' })
export class ParametreNavService extends NavProgressBaseService {
  constructor(router: Router) {
    super(router);
  }

  static isParametreUrl(url: string): boolean {
    const path = normalizePath(url);
    return path === '/main/parametre' || path.startsWith(PARAMETRE_PREFIX);
  }

  isParametreUrl(url: string): boolean {
    return ParametreNavService.isParametreUrl(url);
  }

  protected shouldTrackUrl(url: string): boolean {
    return ParametreNavService.isParametreUrl(url);
  }
}
